import {
  styled,
  Block,
  Icon,
  Select,
  Spacer,
} from "../../../seenspire-library";
import React, { FunctionComponent } from "react";

const VideoContainer = styled(Block)`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 2;
`;

const VideoItemStyled = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const IframeStyled = styled.iframe`
  border: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const VideoItem: FunctionComponent<any> = (props) => {
  return (
    <VideoItemStyled {...props}>
      <source
        src="https://storage.googleapis.com/frontendtesting/frontend/video.webm"
        type="video/webm"
      />
    </VideoItemStyled>
  );
};

const IframeItem: FunctionComponent<any> = (props) => {
  return (
    <IframeStyled
      src="https://social.seenspire.com/footballtesting/1026.1892"
      {...props}
    ></IframeStyled>
  );
};

export { VideoContainer, VideoItem, IframeItem };
